<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="T.CHANGE_ACTIVATION_CONDITION_DIALOG_TITLE | translate"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-link'}"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<mat-form-field class="full-width-form" color="accent">
			<mat-label>{{ T.CHANGE_ACTIVATION_CONDITION_DIALOG_ITEM | translate }}</mat-label>
			<mat-select (selectionChange)="updateActivatedBy($event.value)" [value]="activatedBy()" placeholder="Assessment Item">
				<mat-select-trigger class="triggerCon">
					@if (activatedBy()) {
						<div class="optionContainer">
							<div class="typeIcon">
								@switch (activatedBy().type) {
									@case (ChecklistItemType.YesNoOption) {
										<mat-icon fontIcon="fa-toggle-on" fontSet="fad" inline />
									}
									@case (ChecklistItemType.MultipleChoiceOption) {
										<mat-icon fontIcon="fa-check-double" fontSet="fad" inline />
									}
									@case (ChecklistItemType.SingleChoiceOption) {
										<mat-icon fontIcon="fa-check" fontSet="fad" inline />
									}
									@case (ChecklistItemType.ThreeStarOption) {
										<mat-icon fontIcon="fa-star-half" fontSet="fad" inline />
									}
								}
							</div>
							<div class="typeDescription">
								{{ ChecklistItemType[activatedBy().type] }}
							</div>
							<span class="quillText">
								{{ stripHtml(activatedBy().title) }}
							</span>
						</div>
					}
				</mat-select-trigger>

				<mat-option [value]="null">
					{{ T.CHANGE_ACTIVATION_CONDITION_DIALOG_NO_CONDITION | translate }}
				</mat-option>

				@for (item of assessmentItems; track item.assessableItemId) {
					<mat-option [value]="item">
						<div class="optionContainer">
							<div class="typeIcon">
								@switch (item.type) {
									@case (ChecklistItemType.YesNoOption) {
										<mat-icon fontIcon="fa-toggle-on" fontSet="fad" inline />
									}
									@case (ChecklistItemType.MultipleChoiceOption) {
										<mat-icon fontIcon="fa-check-double" fontSet="fad" inline />
									}
									@case (ChecklistItemType.SingleChoiceOption) {
										<mat-icon fontIcon="fa-check" fontSet="fad" inline />
									}
									@case (ChecklistItemType.ThreeStarOption) {
										<mat-icon fontIcon="fa-star-half" fontSet="fad" inline />
									}
								}
							</div>
							<div class="typeDescription">
								{{ ChecklistItemType[item.type] }}
							</div>
							<span class="quillText">
								{{ stripHtml(item.title) }}
							</span>
						</div>
					</mat-option>
				}
			</mat-select>
		</mat-form-field>

		@if (activatedBy()) {
			<label class="label">{{ T.CHANGE_ACTIVATION_CONDITION_DIALOG_VALUE_LABEL | translate }}</label>

			@switch (activatedBy().type) {
				@case (ChecklistItemType.YesNoOption) {
					<div>
						<sim-slide-toggle-if-else (checkedEmitter)="updateAnswer($event)" [checked]="$any(selectedValue())">
							<ng-container first-option>
								{{ T.SHARED_EXPANSION_NO | translate }}
							</ng-container>
							<ng-container second-option>
								{{ T.SHARED_EXPANSION_YES | translate }}
							</ng-container>
						</sim-slide-toggle-if-else>
					</div>
				}
				@case (ChecklistItemType.ThreeStarOption) {
					<div class="stars">
						@for (_ of maxStars(); track $index) {
							<button (click)="updateAnswer($index)" color="accent" mat-icon-button>
								@if ($index <= $any(selectedValue())) {
									<mat-icon fontIcon="fa-star" fontSet="fas" inline />
								} @else {
									<mat-icon fontIcon="fa-star" fontSet="far" inline />
								}
							</button>
						}
					</div>
				}
				@case (ChecklistItemType.SingleChoiceOption) {
					<mat-radio-group [value]="selectedValue()" (change)="updateAnswer($event.value)">
						@for (option of $any(activatedBy()).selectableOptions; track $index) {
							<mat-radio-button [value]="$index">
								{{ stripHtml($any(option?.option ?? option)) }}
							</mat-radio-button>
						}
					</mat-radio-group>
				}
				@case (ChecklistItemType.MultipleChoiceOption) {
					<div>
						@for (option of $any(activatedBy()).selectableOptions; track $index) {
							<mat-checkbox
								(change)="updateMultipleChoiceAnswer([$index, $event.checked])"
								[checked]="$any(selectedValue()).includes($index)"
							>
								{{ stripHtml($any(option?.option ?? option)) }}
							</mat-checkbox>
						}
					</div>
				}
			}
		}
	</ng-container>

	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontSet: 'fad', fontIcon: 'fa-times'}" [label]="T.BUTTON_CLOSE" color="warn" />

		<sim-button
			(onClick)="changeActivationCondition()"
			[disabled]="isSavingDisabled()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_SAVE"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
